import React from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NotFound from "@components/ui/NotFound";
import {
  YellowRanks,
  GreenRank,
  GrayRank,
  BrownRanks,
  LeaderBoardArrow,
  ViewAllPlayers,
} from "@utils/defaultImages";
import NoHistory from "@features/mindfulness/NoHistory";
import { useTranslation } from "react-i18next";
import ImageWithFallback from "@components/ui/ImageFallback";
const TopPlayers = ({ progressTracker = false, topPlayers = [] }) => {
  const Ranks = [<YellowRanks />, <GrayRank />, <BrownRanks />, <GreenRank />];
  const navigate = useNavigate();
  const { t } = useTranslation();
   return (
    <div
      className="p-6 rounded-lg bg-cover h-full flex flex-col"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex justify-between items-center mb-[50px]">
        <h4 className="text-[16px] font-[Lato] text-white">
          {t("quizGame.Top Players this week")}
        </h4>
      </div>

      {/* White content container - SAME STRUCTURE AS MILESTONE SECTION */}
      <div className="flex-1 flex flex-col">
        <div className="bg-white rounded-[17px] p-4 flex flex-col items-center relative flex-1">
          <img
            src={ViewAllPlayers}
            alt="image"
            className="absolute -top-[8%] 2xl:-top-[12%] left-1/2 -translate-x-1/2 z-[9] w-[40%] sm:w-[25%] md:w-[25%] lg:w-[30%] xl:w-[38%] 2xl:w-[37%] object-cover"
          />
          <p className="text-[16px] font-[Lato] font-[600] text-center !mt-[35%] sm:!mt-[20%] lg:!mt-[26%] xl:!mt-[31%] 2xl:!mt-[30%]">
            {t("See Where You Stand")}
          </p>
          <p className="text-[14px] font-[Lato] font-[400] text-[#5C5C5C] text-center my-3">
            {t(
              "Check your rank and compare your quiz performance with other players."
            )}
          </p>
          <button
            className="bg-[#64DDFF] rounded-full text-[#fff] text-[16px] font-[Lato] py-2 px-3 w-full flex items-center gap-2 justify-center mt-2"
            onClick={() =>
              navigate(
                progressTracker
                  ? "/progress-tracker/weekly-Leader-board"
                  : "/quiz-game/weekly-Leader-board"
              )
            }
          >
            {t("quizGame.View All")} <img src={LeaderBoardArrow} alt="image" />
          </button>
        </div>
      </div>
    </div>
  );

};

export default TopPlayers;
